import { Body2, UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import { ComparisonLandingImage } from './ComparisonLandingImage';
import { type IComparisonAlbum } from '../../repositories/property-comparison/entities/v1_get_comparison_albums/ComparisonAlbum';

import * as styles from './styles.css';

const VISIBLE_IMAGES_COUNT = 3;

export interface IComparisonLandingProps {
  album: IComparisonAlbum;
  url: string;
  onClick(): void;
}

export const ComparisonLanding: React.FC<IComparisonLandingProps> = ({ album, url, onClick }) => {
  const images = React.useMemo(
    () => album.images.slice(0, VISIBLE_IMAGES_COUNT).map(image => image.url),
    [album.images],
  );

  const isEmpty = images.length === 0;

  return (
    <div className={styles['container']} data-name="ComparisonLanding">
      <div className={styles['tile']}>
        <a href={url} className={styles['link-area']} onClick={onClick} aria-label={album.title} />
        <div className={styles['images']}>
          {Array.from({ length: VISIBLE_IMAGES_COUNT }, (_, index) => (
            <div key={index} className={styles['image-wrapper']}>
              <ComparisonLandingImage url={images[index]} hasAddIcon={isEmpty && index === 0} />
            </div>
          ))}
        </div>
        <div className={styles['text']}>
          <UIHeading3>{album.title}</UIHeading3>
          <Body2 color="text-secondary-default">{album.subtitle}</Body2>
        </div>
      </div>
    </div>
  );
};
